// Parse filename from Content-Disposition header (supports RFC 5987 filename*)
function filenameFromHeaders(headers, fallback = "download") {
  const get = (k) => (headers?.get ? headers.get(k) : headers?.[k]);
  const contentDisposition = get("content-disposition");
  if (contentDisposition) {
    const star = /filename\*\s*=\s*UTF-8''([^;]+)/i.exec(contentDisposition);
    if (star) return decodeURIComponent(star[1]);
    const quoted = /filename\s*=\s*"([^"]+)"/i.exec(contentDisposition);
    if (quoted) return quoted[1];
    const plain = /filename\s*=\s*([^;]+)/i.exec(contentDisposition);
    if (plain) return plain[1].trim();
  }
  return fallback;
}

//figure out file extension fron content type
function extFromType(ct = "") {
  if (ct.includes("text/csv")) return ".csv";
  if (
    ct.includes(
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    )
  )
    return ".xlsx";
  if (ct.includes("application/pdf")) return ".pdf";
  if (ct.includes("application/zip")) return ".zip";
  if (ct.includes("text/plain")) return ".txt";
  return "";
}

//sanitizeFilename filename to remove spurious chars and whitespace
function sanitizeFilename(name) {
  return String(name)
    .replace(/[/\\?%*:|"<>]/g, "_")
    .replace(/\s+/g, "_");
}

export default {
  methods: {
    /**
     * Download any streamed/binary response from the backend as a file.
     * Works with Axios responses e.g. after calling endpoint that returns a
     * streamed response:
     *    const stream = await this.$axios.post(...)
     *    await this.downloadStream(stream);
     *
     * @param {Response|Object} response - fetch Response or Axios response
     * @param {Object} [opts]
     * @param {string} [opts.filename]   - preferred fallback filename
     * @param {string} [opts.contentType]- override MIME type if missing
     */
    async downloadStream(response, opts = {}) {
      const isFetch =
        typeof Response !== "undefined" && response instanceof Response;
      const headers = isFetch ? response.headers : response.headers || {};
      const headerCT = isFetch
        ? headers.get("content-type")
        : headers["content-type"];
      const contentType =
        opts.contentType || headerCT || "application/octet-stream";

      // Build Blob
      let blob;
      if (isFetch) {
        blob = await response.blob();
      } else {
        const data = response.data;
        blob =
          data instanceof Blob ? data : new Blob([data], { type: contentType });
      }

      // Filename
      const hinted = opts.filename || "download";
      let name = filenameFromHeaders(headers, hinted);
      if (!/\.[A-Za-z0-9]+$/.test(name)) {
        // work out file extension if none provided
        name += extFromType(blob.type || contentType);
      }
      // clean up name
      name = sanitizeFilename(name);

      // Trigger download
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = name;
      a.style.display = "none";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      setTimeout(() => URL.revokeObjectURL(url), 0);
    },
  },
};
